module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/icon-rumble-679ebbcdf25d91b75a3cb84b2bd0a2c3.png";